import { useQuery } from "@tanstack/react-query";
import { brokerService } from "@/services/brokerService";

export function useBrokerList() {
  return useQuery({ queryKey: ["brokers", "list"], queryFn: brokerService.listBrokers });
}

export function useBrokerStatus() {
  return useQuery({ queryKey: ["brokers", "status"], queryFn: brokerService.getStatus });
}

export function useBrokerCapabilities() {
  return useQuery({
    queryKey: ["brokers", "capabilities"],
    queryFn: brokerService.getCapabilities,
  });
}
